export default __webpack_public_path__ + "static/media/901.74b2ba14.png";